import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { requireRole } from "@/lib/auth/require-role";
import LLMWorkspacePage from "@/features/llm/llm-workspace-page";

// UUID-only with safe fallback: malformed input collapses to undefined (no
// selection), never propagated to UI as a raw user-controlled string.
// Zod strips unknown keys by default, so extra params (?attack=...) are
// discarded before any component reads the search object.
const llmSearchSchema = z.object({
  provider: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_admin/llm")({
  validateSearch: llmSearchSchema.parse,
  beforeLoad: () => requireRole("admin"),
  component: LLMWorkspacePage,
});
